import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";
const firebaseConfig = {
    apiKey: "AIzaSyA8zyRrJZG50zNe6lrYFYC3IuUu9O6qR0E",
    authDomain: "postergen-48af5.firebaseapp.com",
    projectId: "postergen-48af5",
    storageBucket: "postergen-48af5.appspot.com",
    messagingSenderId: "764491450323",
    appId: "1:764491450323:web:f9dd9afad1931416561126"
};

const app = initializeApp(firebaseConfig);

// Get the authentication instance
const auth = getAuth(app);

// Firestore
const db= getFirestore(app);

const storage = getStorage(app);
export { auth , db, storage};